// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"02b468e7","239":"e3950fab","453":"0cbed9ad","455":"d493ee2b"}[chunkId] + ".chunk.js";
};